import { useState } from 'react';
import { format, parseISO, isValid } from 'date-fns';
import { fr } from 'date-fns/locale';
import { CalendarIcon, X } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Calendar } from './ui/calendar';
import { Button } from './ui/button';

export const DatePickerField = ({ value, onChange, className = '', placeholder = 'Choisir une date', testId }) => {
    const [open, setOpen] = useState(false);
    const d = value ? parseISO(value) : null;
    const valid = d && isValid(d);
    return (
        <div className="relative">
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <Button type="button" variant="outline" data-testid={testId}
                        className={`w-full justify-start font-normal bg-white ${valid ? 'text-gray-900' : 'text-gray-400'} ${className}`}>
                        <CalendarIcon className="w-3.5 h-3.5 mr-2 text-gray-400" />
                        {valid ? format(d, 'dd/MM/yyyy') : placeholder}
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="start">
                    <Calendar mode="single" locale={fr} selected={valid ? d : undefined} defaultMonth={valid ? d : undefined} initialFocus
                        onSelect={(x) => { onChange(x ? format(x, 'yyyy-MM-dd') : ''); setOpen(false); }} />
                </PopoverContent>
            </Popover>
            {valid && (
                <button type="button" onClick={() => onChange('')} data-testid={testId ? `${testId}-clear` : undefined}
                    className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-gray-400 hover:text-gray-700" aria-label="Effacer la date">
                    <X className="w-3.5 h-3.5" />
                </button>
            )}
        </div>
    );
};
